import SoundManager from './components/SoundManager';

export default class GameManager {

    constructor(game: Phaser.Game) {

        // Game Events
        game.events.on('pause', function () {
            console.log('Game paused');
            SoundManager.getInstance().stopMusic(); 
        });

        game.events.on('resume', function () {
            console.log('Game resumed');
            SoundManager.getInstance().resumeMusic(); 
        });

        // Event visibility over Game
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') { 
                //
            }
        });
    }
}